<template>
  <v-app style="background: #f7f7f8;">
    
    <dashboard-core-app-bar v-if="!isPublic"/>

    <dashboard-core-drawer v-if="!isPublic"/>

    <dashboard-core-view />
  </v-app>
</template>

<script>

export default {
  	name: 'App',

	components: {
		DashboardCoreAppBar: () => import('./components/core/BarApp'),
		DashboardCoreDrawer: () => import('./components/core/Drawer'),
		DashboardCoreView: () => import('./components/core/View'),
	},
  
  	computed: {
		isPublic () {
			const publicPages = ['/login', '/users/create', '/recover', '/users/recover']
			return publicPages.includes(this.$route.path)
		}
	},
}
</script>